module.exports = __webpack_public_path__ + "static/i_logo.9024bd2f.png";